import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Redirect, Link } from 'react-router-dom'
import ReactGA from 'react-ga';

class ChangePassButton extends React.Component {

    dochangePass = () => {
        ReactGA.pageview('/changePassword');
        this.props.history.push("/changePassword");
    }

    render() {
        return (
            <div className="container">
                <button className="btn btn-primary" onClick={this.dochangePass}>{this.props.strings.CHANGE_PASS_BUTTON_LABEL}</button>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
    }
};

const ConnectedChangePassButton = connect(
    mapStateToProps,
)(ChangePassButton);
export default withRouter(ConnectedChangePassButton);
